import Body, { type BodyProps } from 'storybookConfig/stories/molecules/Body';
import SupportLink from 'storybookConfig/stories/molecules/Link/SupportLink';

export const TERMS_AND_POLICIES_URL = 'https://getcarro.com/terms-and-policies';

export type LegalConsentProps = Pick<BodyProps, 'align'>;

/**
 * Counsel-approved consent line shown above the action buttons on sign up, sign in and the
 * onboarding Review step. Keep the wording verbatim.
 */
const LegalConsent = ({ align }: LegalConsentProps) => (
  <Body as="p" variant="Body/Body Small" align={align}>
    By using or signing up for Carro, you agree to Carro&apos;s Privacy Policy and other{' '}
    <SupportLink href={TERMS_AND_POLICIES_URL}>Terms and Policies</SupportLink>.
  </Body>
);

export default LegalConsent;
